export default __webpack_public_path__ + "static/media/te.23887433.jpg";